import { PlayerAhoyEvent } from "./player_ahoy_event";
import Throttle from '@javascripts/utils/throttle';

export default class PlayerKeyboardPress {
  constructor(tech, uuid, data) {
    this._tech = tech;
    this._uuid = uuid;
    this._data = data;
    this._skipInterval = 5;
    this._throttleInterval = 300;
    this._time = Date.now();
    this._eventTimestamp = {};
    this._whitelistedKeys = [
      'ArrowRight',
      'ArrowLeft',
      'ArrowUp',
      'ArrowDown',
      'Space',
      'Escape',
      'KeyK',
      'KeyF',
      'KeyI',
      'KeyM',
      'KeyC',
      'KeyN',
    ];
  }

  init() {
    this.bindKeydown();
    this.bindKeyup();
  }

  bindKeyup() {
    this.tech().el().el().addEventListener('keyup', (e) => {
      if (this.isWhitelisted(e.code)) {
        const eventTimestamp = this._eventTimestamp[e.code];
        this.handleKeyupEvent(e.code, eventTimestamp);
      }
    });
  }

  bindKeydown() {
    this.tech().el().el().addEventListener('keydown', (e) => {
      if (this.isWhitelisted(e.code)) {
        this.markState(e.code);
        e.preventDefault();

        if (e.code == 'ArrowLeft') {
          this._time = Throttle.execute(this._time, this._throttleInterval, this.callbackLeft.bind(this));
        } else if (e.code == 'ArrowRight' ) {
          this._time = Throttle.execute(this._time, this._throttleInterval, this.callbackRight.bind(this));
        }  else if (e.code == 'ArrowUp' ) {
          this.callbackUp();
        } else if (e.code == 'ArrowDown' ) {
          this.callbackDown();
        } else if (e.code == 'Space' || e.code == 'KeyK') {
          this.callbackSpaceAndKeyK();
        } else if (e.code == 'KeyF') {
          this.callbackFKey();
        } else if (e.code == 'KeyI') {
          this.callbackIKey();
        } else if (e.code == 'Escape' ) {
          this.callbackEscape();
        } else if (e.code == 'KeyM' ) {
          this.callbackMKey();
        } else if (e.code == 'KeyC' ) {
          this.callbackCKey();
        } else if (e.code == 'KeyN' ) {
          this.callbackNKey();
        }
      }
    });
  }

  handleKeyupEvent(keyCode, stateTime) {
    if(Date.now() - stateTime > this.throttleInterval()) {
      PlayerAhoyEvent.sendKeyPressed(keyCode, this.uuid(), true);
    } else {
      PlayerAhoyEvent.sendKeyPressed(keyCode, this.uuid(), false)
    }
    delete this._eventTimestamp[keyCode];
  }

  markState(keyCode) {
    if( !this._eventTimestamp[keyCode] ) {
      this._eventTimestamp[keyCode] = Date.now();
    }
  }

  callbackSpaceAndKeyK() {
    if (this.tech().paused() == true) {
      this.tech().play();
    } else {
      this.tech().pause();
      this.tech().trigger('trigger-pause-ad');
    }
  }

  callbackLeft() {
    if (this.data().isVideo()) {
      this.tech().trigger({
        type: 'vp-before-seeked',
        action: 'keypress'
      });

      const now = this.tech().currentTime();
      this.tech().currentTime(now - this._skipInterval);
    }
  }

  callbackRight() {
    if (this.data().isVideo()) {
      this.tech().trigger({
        type: 'vp-before-seeked',
        action: 'keypress'
      });

      const now = this.tech().currentTime();
      this.tech().currentTime(now + this._skipInterval);
    }
  }

  callbackUp() {
    const volumeStep = this.tech().volume() + 0.1;
    this.tech().volume(volumeStep)
  }

  callbackDown() {
    const volumeStep = this.tech().volume() - 0.1;
    this.tech().volume(volumeStep)
  }

  callbackFKey() {
    const isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;

    if(isFullscreen) {
      this.tech().plugin().instance().player_.exitFullscreen();
    } else {
      this.tech().plugin().instance().player_.requestFullscreen();
    }
  }

  callbackIKey() {
    document.querySelector('.vjs-cinema-mode-button').click();
  }

  callbackEscape() {
    if(this.tech().isFullscreen()) {
      document.exitFullscreen();
    } else {
      var articlePlayer = document.getElementById('article-player');
      if (articlePlayer.className.indexOf('cinema-mode') > -1 ) {
        document.querySelector('.vjs-cinema-mode-button').click();
      }
    }
  }

  callbackMKey() {
    const isMuted = this.tech().muted();
    this.tech().muted(!isMuted);
  }

  callbackCKey() {
    const activeTracks = this.tech().plugin().instance().player_.controlBar.vpSettingsButton.settingsMenuPanel.subtitleManager.getActiveSubtitle().label;
    const userPreferedLang = this.tech().plugin().instance().player_.controlBar.vpSettingsButton.settingsMenuPanel.subtitleManager.getPreferredLang().replace(/^\w/, c => c.toUpperCase());
    const menuItems = this.tech().plugin().instance().player_.controlBar.vpSettingsButton.settingsMenuPanel.subtitleMenu.menuItems;

    // Uncheck Current Subtitle State
    var tracksObject = menuItems.find(item => item.label === activeTracks);
    tracksObject.menuType = "";

    if (activeTracks != "Off") {
      tracksObject = menuItems.find(item => item.label === 'Off');
      this.tech().plugin().instance().player_.controlBar.vpSettingsButton.settingsMenuPanel.subtitleManager.handleTrackChange('Off');
    } else {
      tracksObject = menuItems.find(item => item.label === userPreferedLang);
      this.tech().plugin().instance().player_.controlBar.vpSettingsButton.settingsMenuPanel.subtitleManager.handleTrackChange(userPreferedLang);
    }

    // Check New Subtitle State
    tracksObject.menuType = "checked";
    this.tech().plugin().instance().player_.controlBar.vpSettingsButton.settingsMenuPanel.subtitleMenu.updateList(menuItems);
  }

  callbackNKey() {
    this.tech().plugin().instance().player_.controlBar.vpNextButton.handleClick();
  }

  isWhitelisted(code) {
    return this._whitelistedKeys.indexOf(code) >= 0;
  }

  tech() {
    return this._tech;
  }

  time() {
    return this._time;
  }

  uuid() {
    return this._uuid;
  }

  data() {
    return this._data;
  }

  eventTimestamp() {
    return this._eventTimestamp;
  }

  throttleInterval() {
    return this._throttleInterval;
  }
}
